/* KTE Underground custom audience results sort: draft-only. */
(() => {
  if (window.__kteUndergroundSortReady) return;
  window.__kteUndergroundSortReady = true;
  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('[data-kte-underground-sort]');
    if (!select) return;
    const view = select.closest('.kte-underground-tools');
    const grid = view?.parentElement?.querySelector('.product-grid');
    if (!grid) return;
    const cards = [...grid.querySelectorAll(':scope > .product-grid__item')];
    const number = (node, prop) => Number(node.dataset[prop]) || 0;
    const mode = select.value;
    cards.sort((a,b) => {
      if (mode === 'price-asc') return number(a,'kteSortPrice')-number(b,'kteSortPrice');
      if (mode === 'price-desc') return number(b,'kteSortPrice')-number(a,'kteSortPrice');
      if (mode === 'newest') return number(b,'kteSortDate')-number(a,'kteSortDate');
      if (mode === 'title') return (a.dataset.kteSortTitle||'').localeCompare(b.dataset.kteSortTitle||'');
      return number(a,'kteSortOriginal')-number(b,'kteSortOriginal');
    });
    cards.forEach(card=>grid.appendChild(card));
  });
})();
